import { iTxt, SecurityGuard, useRedirect } from "@duosoftbg/nacid-components";
import React, { Fragment } from "react";
import { getI18n } from "react-i18next";
import styled from "styled-components";
import AdminPageChildrenContent from "./AdminConsolePage";

const SectionPageWrapper = styled.div`
  margin-bottom: 35px;
`;

const MainPageTxt = styled.div`
  font-weight: bold;
  color: #4679b2;
  margin-bottom: 25px;
  margin-top: 25px;
  font-size: 20px;
`;

const AdminConsolePageLink = styled.a`
  color: ${(props) => props.theme.palette.primary.light};

  :hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;

const AdminConsoleSectionContent = ({ page }) => {
  const { redirect } = useRedirect();

  return (
    <SectionPageWrapper key={"section-page-wrapper-" + page.id}>
      <MainPageTxt key={"section-page-txt-" + page.id}>
        {page.href ? (
          <AdminConsolePageLink onClick={() => redirect(page.href)}>
            {iTxt(getI18n().language, page.title, page.titleEn)}
          </AdminConsolePageLink>
        ) : (
          iTxt(getI18n().language, page.title, page.titleEn)
        )}
      </MainPageTxt>
      <AdminPageChildrenContent items={page.children} />
    </SectionPageWrapper>
  );
};

const AdminConsoleSectionContentRenderer = ({ page }) => {
  const accessRoles = page.accessRoles;
  if (accessRoles && accessRoles.length > 0) {
    return (
      <SecurityGuard checkForRoles={accessRoles} roleOperator={"or"}>
        <AdminConsoleSectionContent page={page} />
      </SecurityGuard>
    );
  }

  return <AdminConsoleSectionContent page={page} />;
};

const AdminConsoleSection = ({ section }) => {
  return (
    <>
      {section.pages.map((page) => (
        <Fragment key={"section-main-page" + page.id}>
          <AdminConsoleSectionContentRenderer page={page} />
        </Fragment>
      ))}
    </>
  );
};

const AdminConsoleSectionRenderer = ({ section }) => {
  const accessRoles = section.accessRoles;
  if (accessRoles && accessRoles.length > 0) {
    return (
      <SecurityGuard checkForRoles={accessRoles} roleOperator={"or"}>
        <AdminConsoleSection section={section} />
      </SecurityGuard>
    );
  }

  return <AdminConsoleSection section={section} />;
};

export default AdminConsoleSectionRenderer;
